import http from '../../axios-config/g-http-metodos';

function GetFiliaisAtivas() {
    const { res, erro, requisicao } = http.get(`Filial/GetFiliaisAtivas`)
    return { FilialArray: res, erro, requisicao }
}

const FilialController = {
    GetFiliaisAtivas,
}
  
export default FilialController